var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OpSelect',{ref:"input",attrs:{"suggest":_vm.suggestBank,"suggestValue":_vm.suggestBankValue,"suggestKey":_vm.suggestBankKey,"required":_vm.required,"name":_vm.name,"id":_vm.id,"label":_vm.label},on:{"changed-valid":_vm.changedValid},model:{value:(_vm.dataModel),callback:function ($$v) {_vm.dataModel=$$v},expression:"dataModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }